import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { FormCardDataType, FormCardData } from '../types/types';

export const initialState: FormCardDataType = {
  formCardsData: [],
};

const slice = createSlice({
  name: 'formPageReducer',
  initialState: initialState,
  reducers: {
    updateFormCardsData(state, action: PayloadAction<FormCardData>) {
      state.formCardsData.push(action.payload);
    },
  },
});

export const formPageReducer = slice.reducer;
export const { updateFormCardsData } = slice.actions;
